import React, { useMemo, useState, useEffect } from "react";
import { Modal, Radio, Space, Typography } from "antd";

const { Text } = Typography;

const RemoveQuantityModal = ({
  visible,
  onClose,
  onConfirm,
  ware,
  movement,
  unitKey, // "sale_movement_unit" | "sale_sale_unit"
}) => {
  const [selectedMethod, setSelectedMethod] = useState(null);

  useEffect(() => {
    if (!visible) {
      setSelectedMethod(null);
    }
  }, [visible]);

  const options = useMemo(() => {
    if (!movement || !unitKey) return [];

    const unit = movement[unitKey];
    if (!unit) return [];

    return Object.entries(unit)
      .filter(([, data]) => data && typeof data.quantity === "number" && data.quantity > 0)
      .map(([key, data]) => ({
        key, // payment_method_money, payment_method_card
        quantity: data.quantity,
      }));
  }, [movement, unitKey]);

  if (!visible || options.length <= 1) return null;

  return (
    <Modal
      open={visible}
      title={`Remover quantidade – ${ware.description}`}
      okText="Remover"
      cancelText="Cancelar"
      onOk={() => {
        onConfirm(selectedMethod);
        onClose();
      }}
      onCancel={onClose}
      okButtonProps={{ size: "large", disabled: !selectedMethod }}
      cancelButtonProps={{ size: "large" }}
      destroyOnHidden
    >
      <Radio.Group buttonStyle="solid" size="large" style={{ marginTop: 16 }} onChange={(e) => setSelectedMethod(e.target.value)} value={selectedMethod}>
        <Text>Escolhe de qual método deseja remover 1 unidade:</Text>
        <Space style={{ marginTop: 20 }} orientation="horizontal">
          {options.map((opt) => (
            <Radio.Button key={opt.key} value={opt.key}>
              <Space orientation="vertical" size={0}>
                <Text>{opt.key === "payment_method_money" ? "Dinheiro" : "Cartão"}</Text>
                <Text type="secondary">Quantidade: {opt.quantity}</Text>
              </Space>
            </Radio.Button>
          ))}
        </Space>
      </Radio.Group>
    </Modal>
  );
};

export default RemoveQuantityModal;
